<template>
  <!-- confirmModal -->
  <div
    class="modal fade"
    id="about-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mySmallModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modal">{{ $t("about-us") }}</h5>
          <!-- <button type="button" class="close" @click="closeModal()">
            <span aria-hidden="true" class="zmdi zmdi-close zmdi-hc-2x"></span>
          </button> -->
          <div
            class="ml-auto pointer"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal()"
          >
            <i class="fa-solid fa-xmark fa-xl text-darkdark"></i>
          </div>
        </div>
        <div class="modal-body">
          <div v-if="contentList.length !== 0">
            <p v-for="c in contentList">
              <span v-if="c.key !== 'Name'">{{ c.key }} : </span
              ><span class="msu-semibold s-text">{{ c.value }}</span>
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            @click="closeModal()"
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  contentList: { type: Array, default: () => [] },
});
const closeModal = () => {
  $(`#about-modal`).modal("hide");
};
</script>
<style lang="scss">
.confirm-title {
  min-height: 52px;
  height: 52px;
}
.title-height {
  min-height: 52px;
  height: 52px;
}
</style>
